import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const OfflineNotification = lazy(() => import('.'))

class OfflineNotificationWebComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<OfflineNotification />
			</RootProviders>
		)
	}
}

customElements.define('offline-notification', OfflineNotificationWebComponent)
